/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type freeShippingHelpers_item = {
    readonly vertical: VerticalType | null;
    readonly shipmentQuotes: ReadonlyArray<{
        readonly isComplimentary: boolean | null;
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
        readonly serviceMethod: {
            readonly region: {
                readonly regionName: string | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": "freeShippingHelpers_item";
};
export type freeShippingHelpers_item$data = freeShippingHelpers_item;
export type freeShippingHelpers_item$key = {
    readonly " $data"?: freeShippingHelpers_item$data;
    readonly " $fragmentRefs": FragmentRefs<"freeShippingHelpers_item">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "freeShippingHelpers_item"
};
(node as any).hash = '0f9f60d2da34f2b96f363fbf4179c2be';
export default node;
